import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function Filters(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '0px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2 style={{whiteSpace:'normal', paddingRight:'10px'}}>Signal Filters</h2>
                <li>
                    <Link to={`${url}/signals`}>Signals</Link>
                </li>
                <li>
                    <Link to={`${url}/basic`}>Basic Filters</Link>
                </li>
                <li>
                    <Link to={`${url}/lowpass`}>Lowpass Filters</Link>
                </li>
                <li>
                    <Link to={`${url}/highpassfilters`}>Highpass Filters</Link>
                </li>  
                <li>
                    <Link to={`${url}/bandpass`}>Bandpass Filters</Link>
                </li>
                <li>
                    <Link to={`${url}/notchpass`}>Notchpass Filters</Link>
                </li>   
<li>
                    <Link to={`${url}/seriesprotocols`}>Series Protocols</Link>
                </li>  
                       <li>
                    <Link to={`${url}/canbus`}>CAN Bus</Link>
                </li>     
                  <li>
                    <Link to={`${url}/pwm`}>PWM Control</Link>
                </li>                         
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default Filters; 